import {Box} from 'quickstart/components/layout/Box'
import styled, {css, system, th} from 'quickstart/system'

export const Section = styled(Box).attrs(props => ({
  as: props.as || 'section',
}))(
  ({variant}) => css`
    ${th(`sections.${variant || 'default'}`)};
    ${system};
  `,
)
